import React from "react";
import { useTranslation } from "react-i18next";

export default function HowFundsFlow() {
  const { t } = useTranslation();

  const steps = [
    {
      key: 'deposit',
      text: t('components.checkDepositModal.howFundsFlow.steps.deposit'),
      position: 'top' as const,
      alignment: 'left' as const
    },
    {
      key: 'launchCampaign',
      text: t('components.checkDepositModal.howFundsFlow.steps.launchCampaign'),
      position: 'bottom' as const,
      alignment: 'center' as const
    },
    {
      key: 'matchInfluencers',
      text: t('components.checkDepositModal.howFundsFlow.steps.matchInfluencers'),
      position: 'top' as const,
      alignment: 'center' as const
    },
    {
      key: 'confirmApplication',
      text: t('components.checkDepositModal.howFundsFlow.steps.confirmApplication'),
      position: 'bottom' as const,
      alignment: 'center' as const,
      subText: t('components.checkDepositModal.howFundsFlow.steps.fundsLocked')
    },
    {
      key: 'delivery',
      text: t('components.checkDepositModal.howFundsFlow.steps.delivery'),
      position: 'top' as const,
      alignment: 'center' as const
    },
    {
      key: 'fundsReleased',
      text: t('components.checkDepositModal.howFundsFlow.steps.fundsReleased'),
      position: 'bottom' as const,
      alignment: 'right' as const
    }
  ];

  return (
    <div className="mt-[40px] w-full">
      <div className="w-[956px] inline-flex flex-col justify-start items-start gap-1">
        <div className="justify-start text-neutral-900 text-xl font-semibold font-['DM_Sans'] leading-loose">
          {t('components.checkDepositModal.howFundsFlow.title')}
        </div>
        <div className="justify-center text-font&icon-secondary text-sm font-normal font-['DM_Sans'] leading-snug">
          {t('components.checkDepositModal.howFundsFlow.description')}
        </div>
      </div>
      
      {/* 资金流程时间线 */}
      <div className="mt-6 w-full flex justify-center">
        <div className="relative w-full pt-10 pb-[60px]">
          {/* 节点和文案 */}
          <div className="relative flex items-center">
            {steps.map((step, index) => (
              <React.Fragment key={step.key}>
                <div className="flex flex-col items-center relative">
                  {/* 橙色圆点 */}
                  <div className="w-2 h-2 bg-primary rounded-full z-10 relative"></div>
                  
                  {/* 文案容器 */}
                  <div className={`absolute ${step.position === 'top' ? '-top-8' : 'top-6'} ${
                    step.alignment === 'left' ? 'left-0' : 
                    step.alignment === 'right' ? 'right-0' : 
                    'left-1/2 transform -translate-x-1/2'
                  } ${
                    step.alignment === 'center' ? 'text-center' : 
                    step.alignment === 'left' ? 'text-left' : 
                    'text-right'
                  }`}>
                    <div className="text-sm font-medium text-[#171717] whitespace-nowrap">
                      {step.text}
                    </div>
                    {step.subText && (
                      <div className="text-sm font-medium text-[#171717] whitespace-nowrap mt-1">
                        {step.subText}
                      </div>
                    )}
                  </div>
                </div>
                
                {/* 连接线 - 除了最后一个节点 */}
                {index < steps.length - 1 && (
                  <div className="flex-1 h-[1px] bg-[#E7E5E4] mx-1"></div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
